import { Component } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatIcon } from '@angular/material/icon';
import { Router } from '@angular/router';
import { TranslatePipe } from '../../../pipes/translate.pipe';
import { UserService } from 'src/app/shared/services/user.service';
import { TranslationService } from 'src/app/shared/services/translation.service';

@Component({
  selector: 'app-profile-udated',
  imports: [MatIcon, TranslatePipe],
  templateUrl: './profile-udated.component.html',
  styleUrl: './profile-udated.component.scss',
})
export class ProfileUdatedComponent {
  protected isProfileSettings = false;
  constructor(
    // private profileService: ProfileService,
    private userService: UserService,
    // private _adapter: DateAdapter<unknown>,
    private translationService: TranslationService,
    private router: Router
  ) {
    this.userService
      .getUser()
      .pipe(takeUntilDestroyed())
      .subscribe((user) => {
        // profileService is commented out — nothing to do here
      });
  }

  async ngOnInit(): Promise<void> {
    if (this.router.url.includes('/profileSettings')) {
      this.isProfileSettings = true;
    }
  }

  goHome(): void {
    this.router.navigate(['/']);
  }
}
